$(document).ready(function () {
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  $(".product-selector_atc").click(function () {
    if ($(this).attr("data-mode-champs") == "true") {
      var newUrl = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-champs-url");

      window.location.href = newUrl;
    } else {
      var currentId = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-id");
      var mode = $(".product-selector_outer.active_block").attr("data");
      var currentSellingPlan = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-selling-plan");
      if (mode == "sub") {
        data = {
          id: currentId,
          quantity: 1,
          selling_plan: currentSellingPlan,
        };
      } else {
        data = {
          id: currentId,
          quantity: 1,
        };
      }

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {},
        error: function () {
          alert("Error adding item to the cart.");
        },
      });
    }
  });
});
